import { StatePropertyRef } from '../ExtendableStore';

export const IsDeveloperMode = StatePropertyRef<boolean>('isDeveloperMode', false);
